<script setup lang="ts">
import { UIIcon } from '@groover-dev/groover-ui'

import { useGetMediaUrl } from '~/composables/useGetMediaUrl'

import { trackEvent } from '~/helpers/LegacyTrackEvent'

const socialMediaLinks: { name: string; link: string; icon: string }[] = [
  {
    name: 'Facebook',
    link: 'https://www.facebook.com/HeyGroover/',
    icon: 'fa-brands:facebook-square',
  },
  {
    name: 'Instagram',
    link: 'https://www.instagram.com/groover.music/',
    icon: 'fa-brands:instagram',
  },
  {
    name: 'YouTube',
    link: 'https://www.youtube.com/channel/UCKOgjV7c-ElSjwUzsZvIvWQ',
    icon: 'fa-brands:youtube',
  },
  {
    name: 'Spotify',
    link: 'https://open.spotify.com/user/xa5jpotdh03zb469lofbv9u0m?si=Yyat1XvjSvCEfEAe2w4n-g',
    icon: 'fa-brands:spotify',
  },
  {
    name: 'Twitter',
    link: 'https://twitter.com/heygroover/',
    icon: 'fa6-brands:x-twitter',
  },
]

const route = useRoute()
const { getMediaUrl } = useGetMediaUrl()

function trackExternalVisit({ name }: { name: string }): void {
  trackEvent(
    {
      category: 'External Visit',
      action: name,
      origin: 'Footer',
    },
    route,
  )
}
</script>

<template>
  <div class="topContainer tw-mx-auto sm:tw-mx-0">
    <NuxtLinkLocale
      class="tw-mb-3 tw-flex tw-items-center tw-justify-center sm:tw-justify-start"
      to="/"
    >
      <img
        :src="getMediaUrl('GrooverLogoWithText-White.svg')"
        width="136px"
        alt="Groover logo"
        loading="lazy"
      />
    </NuxtLinkLocale>
    <div
      class="tw-mx-auto tw-flex tw-w-full tw-justify-center tw-gap-x-md sm:tw-justify-start"
    >
      <a
        v-for="{ name, link, icon } in socialMediaLinks"
        :key="name"
        :href="link"
        target="_blank"
        @click="trackExternalVisit({ name })"
      >
        <UIIcon :name="icon" size="sm" :aria-label="name" />
      </a>
    </div>
  </div>
</template>
